module.exports = __webpack_public_path__ + "img/ZM.fb24a131.svg";